"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardLiveChange = exports.CARD_CHANGE_NOT_DRAWN_MESSAGE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OoxmlContent = _interopRequireDefault(require("@common/components/remedy/OoxmlContent"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _revisionTitle = require("@common/components/remedy/revision-title");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _useLiveProposal = require("../../../hooks/use-live-proposal");
var _LiveProposalPanel = require("../../redline/LiveProposalPanel");
var _SectionBoundary = require("../../SectionBoundary");
var _cardLiveProposal = require("./card-live-proposal");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["applied"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CARD_CHANGE_NOT_DRAWN_MESSAGE = exports.CARD_CHANGE_NOT_DRAWN_MESSAGE = "This change could not be drawn.";
var EXCERPT_TYPOGRAPHY = {
  fontFamily: "inherit",
  fontSize: "inherit",
  lineHeight: "inherit",
  letterSpacing: "inherit"
};
var CARD_MARKUP_EXCERPT_AUTHORS = [_proposedRevisions.PROPOSED_REVISIONS_AUTHOR];
var CARD_CHANGE_NOT_DRAWN_FALLBACK = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
  className: "text-[11px] text-[#B45309]",
  children: CARD_CHANGE_NOT_DRAWN_MESSAGE
});
function excerptOf(packageOoxml, changeExcerpt) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "text-[11px] leading-[16px]",
    "data-sentry-component": "excerptOf",
    "data-sentry-source-file": "CardLiveChange.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OoxmlContent.default, {
      ooxml: packageOoxml,
      style: EXCERPT_TYPOGRAPHY,
      getHtmlTitleProp: _revisionTitle.revisionTitleOf,
      drawMoveMarks: true,
      drawReplacementGaps: true,
      changeExcerpt: changeExcerpt,
      "data-sentry-element": "OoxmlComponent",
      "data-sentry-source-file": "CardLiveChange.tsx"
    })
  });
}
function cardMarkupExcerptOf(preview, blockLimit) {
  if (preview.redlineOoxml === null || preview.redlineOoxml.length === 0) return null;
  var changeExcerpt = {
    contextUnits: _cardLiveProposal.CARD_EXCERPT_CONTEXT_UNITS,
    changeAuthors: CARD_MARKUP_EXCERPT_AUTHORS,
    changeStamps: [],
    countsMovesAsChanges: true,
    blockLimit: blockLimit
  };
  return excerptOf(_proposedRevisions.ProposedRevisions.relabelNewestStamp(preview.redlineOoxml), changeExcerpt);
}
var PendingCardChange = function PendingCardChange(_ref) {
  var _request$bookmarkName, _request$redline, _request$editLayer, _preview$editLayer$te, _preview$editLayer;
  var preview = _ref.preview,
    signedInAuthorName = _ref.signedInAuthorName,
    blockLimit = _ref.blockLimit;
  var request = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.liveProposalRequestOf)(preview, signedInAuthorName);
  }, [preview, signedInAuthorName]);
  var state = (0, _useLiveProposal.useLiveProposal)({
    bookmarkNames: (_request$bookmarkName = request === null || request === void 0 ? void 0 : request.bookmarkNames) !== null && _request$bookmarkName !== void 0 ? _request$bookmarkName : [],
    redline: (_request$redline = request === null || request === void 0 ? void 0 : request.redline) !== null && _request$redline !== void 0 ? _request$redline : null,
    editLayer: (_request$editLayer = request === null || request === void 0 ? void 0 : request.editLayer) !== null && _request$editLayer !== void 0 ? _request$editLayer : null,
    enabled: request !== null,
    hold: "pageOnly"
  });
  var textRedlineShown = (_preview$editLayer$te = (_preview$editLayer = preview.editLayer) === null || _preview$editLayer === void 0 ? void 0 : _preview$editLayer.textRedline) !== null && _preview$editLayer$te !== void 0 ? _preview$editLayer$te : preview.textRedline;
  var shownPackage = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.shownPreviewPackageOf)(state.previewPackageOoxml, state.stampedAt, textRedlineShown);
  }, [state.previewPackageOoxml, state.stampedAt, textRedlineShown]);
  var changeExcerpt = (0, _react.useMemo)(function () {
    return (0, _cardLiveProposal.cardExcerptOptionsOf)({
      stampedAt: state.stampedAt
    }, preview, blockLimit);
  }, [state.stampedAt, preview, blockLimit]);
  if (request === null) return cardMarkupExcerptOf(preview, blockLimit);
  var proposalWasBuilt = state.status === "proposed" || state.status === "live";
  if (proposalWasBuilt && state.changeCount === 0) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "text-[11px] italic text-[#686766]",
    children: _LiveProposalPanel.DOCUMENT_ALREADY_READS_AS_PROPOSED_MESSAGE
  });
  var errorLine = state.status === "error" && state.error !== null ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "text-[11px] text-[#B45309]",
    children: state.error
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [shownPackage ? excerptOf(shownPackage, changeExcerpt) : null, errorLine]
  });
};
var AppliedCardChange = function AppliedCardChange(_ref2) {
  var _preview$editLayer$te2, _preview$editLayer2;
  var preview = _ref2.preview,
    signedInAuthorName = _ref2.signedInAuthorName,
    blockLimit = _ref2.blockLimit;
  var registry = (0, _useLiveProposal.useLiveProposalRegistry)();
  var request = (0, _cardLiveProposal.liveProposalRequestOf)(preview, signedInAuthorName);
  var appliedLook = request === null ? null : registry.appliedLookOf(request);
  if (appliedLook === null) return cardMarkupExcerptOf(preview, blockLimit);
  var textRedlineShown = (_preview$editLayer$te2 = (_preview$editLayer2 = preview.editLayer) === null || _preview$editLayer2 === void 0 ? void 0 : _preview$editLayer2.textRedline) !== null && _preview$editLayer$te2 !== void 0 ? _preview$editLayer$te2 : preview.textRedline;
  var shownPackage = (0, _cardLiveProposal.shownPreviewPackageOf)(appliedLook.previewPackageOoxml, appliedLook.stampedAt, textRedlineShown);
  return shownPackage ? excerptOf(shownPackage, (0, _cardLiveProposal.cardExcerptOptionsOf)({
    stampedAt: appliedLook.stampedAt
  }, preview, blockLimit)) : null;
};
var CardLiveChange = exports.CardLiveChange = /*#__PURE__*/_react.default.memo(function (_ref3) {
  var applied = _ref3.applied,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SectionBoundary.SectionBoundary, {
    section: "card_change",
    fallback: CARD_CHANGE_NOT_DRAWN_FALLBACK,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.InsideRedlinePreview, {
      children: applied ? /*#__PURE__*/(0, _jsxRuntime.jsx)(AppliedCardChange, _objectSpread({}, props)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(PendingCardChange, _objectSpread({}, props))
    })
  });
});